/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

import { Renderer2, ViewContainerRef, ComponentFactoryResolver, Directive, ElementRef, EventEmitter, Input, Output, TemplateRef, Host, Optional } from "@angular/core";
import { UiTSType } from "@webapp/ui/core/models/ui-type.models";
import { UiTooltipTrigger } from "@webapp/ui/tooltip/tooltip.models";
import { NzConfigService, WithConfig } from "ng-zorro-antd/core/config";
import { NgStyleInterface } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { NzPopconfirmDirective } from "ng-zorro-antd/popconfirm";
import { UiAutoFocusType } from "../popconfirm.models";

@Directive({
  selector: "[ui-popconfirm]",
  exportAs: "uiPopconfirm",
})
export class UiPopconfirmDirective extends NzPopconfirmDirective {
  @Input("uiArrowPointAtCenter")
  @InputBoolean()
  public arrowPointAtCenter?: boolean;
  @Input("uiPopconfirmTitle")
  public title?: UiTSType;
  @Input("ui-popconfirm")
  public directiveTitle?: UiTSType | null;
  @Input("uiTrigger")
  public trigger?: UiTooltipTrigger = "click";
  @Input("uiPlacement")
  public placement?: string | string[] = "top";
  @Input("uiOrigin")
  public origin?: ElementRef<HTMLElement>;
  @Input("uiMouseEnterDelay")
  public mouseEnterDelay?: number;
  @Input("uiMouseLeaveDelay")
  public mouseLeaveDelay?: number;
  @Input("uiOverlayClassName")
  public overlayClassName?: string;
  @Input("uiOverlayStyle")
  public overlayStyle?: NgStyleInterface;
  @Input("uiVisible")
  public visible?: boolean;
  @Input("uiOkText")
  public nzOkText?: string;
  @Input("uiOkType")
  public nzOkType?: string;
  @Input("uiOkDanger")
  public nzOkDanger?: boolean;
  @Input("uiCancelText")
  public nzCancelText?: string;
  @Input("uiIcon")
  public nzIcon?: string | TemplateRef<void>;
  @Input("uiCondition")
  @InputBoolean()
  public nzCondition = false;
  @Input("uiShowArrow")
  @InputBoolean()
  public nzPopconfirmShowArrow = true;
  @Input("uiBackdrop")
  @WithConfig()
  public nzPopconfirmBackdrop? = false;
  @Input("uiAutofocus")
  @WithConfig()
  public nzAutofocus: UiAutoFocusType = null;

  @Output("uiVisibleChange")
  public readonly visibleChange = new EventEmitter<boolean>();
  @Output("uiOnCancel")
  public readonly nzOnCancel = new EventEmitter<void>();
  @Output("uiOnConfirm")
  public readonly nzOnConfirm = new EventEmitter<void>();

  constructor(
    elementRef: ElementRef,
    hostView: ViewContainerRef,
    resolver: ComponentFactoryResolver,
    renderer: Renderer2,
    @Host() @Optional() noAnimation?: NzNoAnimationDirective,
    nzConfigService?: NzConfigService
  ) {
    super(elementRef, hostView, resolver, renderer, noAnimation, nzConfigService);
  }
}
